import { useTranslation } from 'react-i18next';
import { Button, Flex, Typography } from 'antd';
import { useTripTaskStore } from 'shared/stores';
import type { TCreationMode } from '../../types';
import { CREATION_MODE_OPTIONS } from './constants';
import styles from './creation-mode.module.scss';

export const CreationMode = () => {
  const { t } = useTranslation('trip');
  const { creationMode, setCreationMode } = useTripTaskStore();

  return (
    <Flex gap='middle' vertical>
      <Typography.Text type='secondary'>{t('create_tasks_step_creation_mode_helper')}</Typography.Text>
      <Flex gap='small'>
        {CREATION_MODE_OPTIONS.map((option) => (
          <Button
            key={option.value}
            className={styles.option}
            type={creationMode === option.value ? 'primary' : 'default'}
            size='large'
            onClick={() => setCreationMode(option.value as TCreationMode)}>
            {option.icon}
            {option.label}
          </Button>
        ))}
      </Flex>
    </Flex>
  );
};
